module.exports = __webpack_public_path__ + "static/media/exposure.5017a77a.png";